import Error from 'components/error';
import { NextPage } from 'next';
import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
const NotFoundPage: NextPage = () => {
  return <Error statusCode={404} />;
};

export default NotFoundPage;

export async function getStaticProps(ctx) {
  const locale = ctx.locale || 'en';

  const translations = await serverSideTranslations(locale, ['common']);

  return {
    props: {
      ...translations,
    },
  };
}
